import React, { useState, useEffect, Fragment } from "react";
import Axios from "axios";
import {toast} from "react-toastify";

// Components
import SearchResults from "./SearchResults";
import {StaticData} from '../../context/staticData';

export default function Search({ searchResultsUrl, vehicleSearchUrl, query, customOptions }) {
    const [searchResults, setSearchResults] = useState({});
    const [vehicleResults, setVehicleResults] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (query !== "" && query.length > 1) {
            fetchResults();
        }

        history.replaceState(null, null, "?query=" + query);
    }, [query]);

    async function fetchResults() {
        setLoading(true);

        try {
            const [searchResults, vehicleSearchResults] = await Axios.all([
                Axios.get(searchResultsUrl, { params: { query: query } }),
                Axios.get(vehicleSearchUrl, { params: { query: query } })
            ]);

            if (searchResults.data) {
                setSearchResults(searchResults.data);
            } else {
                toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
            }

            if (vehicleSearchResults.data) {
                setVehicleResults(vehicleSearchResults.data.items);
            } else {
                toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
            throw new Error(error);
        }
    }

    return (
        <StaticData.Provider value={{ customOptions }}>
            {Object.entries(searchResults).length !== 0 && (
                <Fragment>
                    <SearchResults
                        vehicleResults={vehicleResults}
                        searchResults={searchResults}
                        query={query}
                        vehicleLimit={Infinity}
                        pageLimit={Infinity}
                        loading={loading}
                    />
                </Fragment>
            )}
        </StaticData.Provider>
    );
}
